import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f9a62c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "email-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "email-label" }, "Add your email to get notified", -1))
const _hoisted_3 = { class: "email-box" }
const _hoisted_4 = ["value", "disabled"]
const _hoisted_5 = { class: "check-box-container" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, "Subscribe to updates from this creator", -1))

import { CheckIcon, EnvelopeIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import { computed, ref, watch } from 'vue';
import { usePatchSignup } from '@/composables/signup';
import { RequirementWithCollectorData, useClaimStore } from '@/store/claimStore';

// From https://emailregex.com/
const subscribed = false;


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailRequirement',
  props: {
    requirement: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const emailRegex =
  // eslint-disable-next-line no-control-regex
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

const store = useClaimStore();

const { patch } = usePatchSignup({
  onSuccess: () => {
    // console.log('email updated');
  },
  onError: (_error: any) => {
    // console.log('Error updating email', error);
  },
});



const email = ref<string>();

const storedEmail = computed(() => {
  const emailRequirement = store.emailRequirements.find(
    (requirement) => requirement.type === 'email'
  );
  const requirementEmail = emailRequirement?.userData?.email;
  return requirementEmail;
});

watch(storedEmail, (newEmail) => {
  if (!email.value) {
    email.value = newEmail;
  }
});

const onSubscribeToggle = (event: any) => {
  if (event.target.checked) {
    store.subscribed = true;
  } else {
    store.subscribed = false;
  }
};

async function onEmailInput(event: { target: { value: string } }) {
  console.log('validating email', emailRegex.test(event.target.value));
  const isValidEmail = emailRegex.test(event.target.value);
  if (!isValidEmail) {
    return;
  }
  await patch({
    userData: { email: event.target.value },
    index: props.requirement.index,
    type: props.requirement.type,
  });
  email.value = event.target.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`email-requirements ${_ctx.disabled ? 'disabled' : ''}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (props.requirement.complete)
        ? (_openBlock(), _createBlock(_unref(CheckIcon), {
            key: 0,
            class: "email-icon success"
          }))
        : (props.requirement.error)
          ? (_openBlock(), _createBlock(_unref(XMarkIcon), {
              key: 1,
              class: "email-icon error"
            }))
          : (_openBlock(), _createBlock(_unref(EnvelopeIcon), {
              key: 2,
              class: "email-icon"
            })),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        class: "email-input",
        name: "email",
        type: "email",
        placeholder: "",
        value: email.value,
        onInput: onEmailInput,
        disabled: props.disabled
      }, null, 40, _hoisted_4)
    ]),
    _createElementVNode("label", _hoisted_5, [
      _createElementVNode("input", {
        type: "checkbox",
        name: "subscribe",
        checked: subscribed,
        onChange: onSubscribeToggle,
        disabled: !storedEmail.value || props.disabled
      }, null, 40, _hoisted_6),
      _hoisted_7,
      _hoisted_8
    ])
  ], 2))
}
}

})